<template>
  <v-content class="pa-12">
    <!-- Nevigater -->
    <v-layout mb-6>
      <v-flex shrink d-flex justify-start align-center style="color: #3E7662;font-weight: bold;font-size: 24px;">
        <span>Post Approve</span>
      </v-flex>
    </v-layout>

    <v-layout mt-6>
      <v-flex shrink style="font-weight: bold;">
        <span>กรองประเภท</span>
      </v-flex>
    </v-layout>

    <!--        <v-layout mt-6>-->
    <!--            <v-flex style="color: #3E7662;">-->
    <!--                <v-radio-group hide-details v-model="filter">-->

    <!--                    <v-layout>-->
    <!--                        <v-flex class="xs6 py-1">-->
    <!--                            <v-layout>-->
    <!--                                <v-flex class="xs1 align-center d-flex justify-end">-->
    <!--                                    <v-icon v-if="countRF12 > 0" small color="#CC3D45">mdi-alert-circle</v-icon>-->
    <!--                                    <span style="color: #CC3D45;font-weight: bold;font-size: 14px" v-if="countRF12 > 0">{{countRF12}}</span>-->
    <!--                                </v-flex>-->
    <!--                                <v-flex>-->
    <!--                                    <v-radio class="ml-3"-->
    <!--                                             @click.native="checkRadio('1')"-->
    <!--                                             :class="checkRadio1 ? 'radio-checked' : ''"-->
    <!--                                             color="#3E7662"-->
    <!--                                             label="รายงานแก้ไขเพิ่มเติมโครงร่างการวิจัย (Amendment Protocol)"-->
    <!--                                             value="1"-->
    <!--                                    />-->
    <!--                                </v-flex>-->
    <!--                            </v-layout>-->
    <!--                        </v-flex>-->
    <!--                        <v-flex class="xs6 py-1">-->
    <!--                            <v-layout>-->
    <!--                                <v-flex class="xs1 align-center d-flex justify-end">-->
    <!--                                    <v-icon v-if="countRF04_1 > 0" small color="#CC3D45">mdi-alert-circle</v-icon>-->
    <!--                                    <span style="color: #CC3D45;font-weight: bold;font-size: 14px" v-if="countRF04_1 > 0">{{countRF04_1}}</span>-->
    <!--                                </v-flex>-->
    <!--                                    <v-flex>-->
    <!--                                    <v-radio class="ml-3"-->
    <!--                                             @click.native="checkRadio('2')"-->
    <!--                                             :class="checkRadio2 ? 'radio-checked' : ''"-->
    <!--                                             color="#3E7662"-->
    <!--                                             label="รายงานเหตุการณ์การไม่พึ่งประสงค์ (SAE report)"-->
    <!--                                             value="2"-->
    <!--                                    />-->
    <!--                                </v-flex>-->
    <!--                            </v-layout>-->
    <!--                        </v-flex>-->
    <!--                    </v-layout>-->

    <!--                    <v-layout>-->
    <!--                        <v-flex class="xs6 py-1">-->
    <!--                            <v-layout>-->
    <!--                                <v-flex class="xs1 align-center d-flex justify-end">-->
    <!--                                    <v-icon v-if="countRF05 > 0" small color="#CC3D45">mdi-alert-circle</v-icon>-->
    <!--                                    <span style="color: #CC3D45;font-weight: bold;font-size: 14px" v-if="countRF05 > 0">{{countRF05}}</span>-->
    <!--                                </v-flex>-->
    <!--                                <v-flex>-->
    <!--                                    <v-radio class="ml-3"-->
    <!--                                             @click.native="checkRadio('3')"-->
    <!--                                             :class="checkRadio3 ? 'radio-checked' : ''"-->
    <!--                                             color="#3E7662"-->
    <!--                                             label="รายงานการเบี่ยงเบนโครงร่างวิจัย (Deviation Report)"-->
    <!--                                             value="3"-->
    <!--                                    />-->
    <!--                                </v-flex>-->
    <!--                            </v-layout>-->

    <!--                        </v-flex>-->
    <!--                        <v-flex class="xs6 py-1">-->
    <!--                            <v-layout>-->
    <!--                                <v-flex class="xs1 align-center d-flex justify-end">-->
    <!--                                    <v-icon v-if="countRF03 > 0" small color="#CC3D45">mdi-alert-circle</v-icon>-->
    <!--                                    <span style="color: #CC3D45;font-weight: bold;font-size: 14px" v-if="countRF03 > 0">{{countRF03}}</span>-->
    <!--                                </v-flex>-->
    <!--                                <v-flex>-->
    <!--                                    <v-radio class="ml-3"-->
    <!--                                             @click.native="checkRadio('4')"-->
    <!--                                             :class="checkRadio4 ? 'radio-checked' : ''"-->
    <!--                                             color="#3E7662"-->
    <!--                                             label="รายงานความก้าวหน้าและขอต่ออายุโครงการวิจัย (Progress Report)"-->
    <!--                                             value="4"-->
    <!--                                    />-->
    <!--                                </v-flex>-->
    <!--                            </v-layout>-->
    <!--                        </v-flex>-->
    <!--                    </v-layout>-->

    <!--                    <v-layout>-->
    <!--                        <v-flex class="xs6 py-1">-->
    <!--                            <v-layout>-->
    <!--                                <v-flex class="xs1 align-center d-flex justify-end">-->
    <!--                                    <v-icon v-if="countRF06 > 0" small color="#CC3D45">mdi-alert-circle</v-icon>-->
    <!--                                    <span class="ml-2" style="color: #CC3D45;font-weight: bold;" v-if="countRF06 > 0">{{countRF06}}</span>-->
    <!--                                </v-flex>-->
    <!--                                <v-flex>-->
    <!--                                    <v-radio class="ml-3"-->
    <!--                                             @click.native="checkRadio('5')"-->
    <!--                                             :class="checkRadio5 ? 'radio-checked' : ''"-->
    <!--                                             color="#3E7662"-->
    <!--                                             label="รายงานสรุปผลการวิจัย (Final Report)"-->
    <!--                                             value="5"-->
    <!--                                    />-->
    <!--                                </v-flex>-->
    <!--                            </v-layout>-->
    <!--                        </v-flex>-->
    <!--                        <v-flex class="xs6 py-1">-->
    <!--                            <v-layout>-->
    <!--                                <v-flex class="xs1 align-center d-flex justify-end">-->
    <!--                                    <v-icon v-if="countRF07 > 0" small color="#CC3D45">mdi-alert-circle</v-icon>-->
    <!--                                    <span style="color: #CC3D45;font-weight: bold;font-size: 14px" v-if="countRF07 > 0">{{countRF07}}</span>-->
    <!--                                </v-flex>-->
    <!--                                <v-flex>-->
    <!--                                    <v-radio class="ml-3"-->
    <!--                                             @click.native="checkRadio('7')"-->
    <!--                                             :class="checkRadio7 ? 'radio-checked' : ''"-->
    <!--                                             color="#3E7662"-->
    <!--                                             label="แจ้งปิดโครงการวิจัยก่อนกำหนด (Terminate)"-->
    <!--                                             value="7"-->
    <!--                                    />-->
    <!--                                </v-flex>-->
    <!--                            </v-layout>-->
    <!--                        </v-flex>-->
    <!--                    </v-layout>-->

    <!--                    <v-layout>-->
    <!--                        <v-flex class="xs6 py-1">-->
    <!--                            <v-layout>-->
    <!--                                <v-flex class="xs1 align-center d-flex justify-end">-->
    <!--                                    <v-icon v-if="countRF04_2 > 0" small color="#CC3D45">mdi-alert-circle</v-icon><span style="color: #CC3D45;font-weight: bold;font-size: 14px" v-if="countRF04_2 > 0">{{countRF04_2}}</span>-->
    <!--                                </v-flex>-->
    <!--                                <v-flex>-->
    <!--                                    <v-radio class="ml-3"-->
    <!--                                             @click.native="checkRadio('8')"-->
    <!--                                             :class="checkRadio8 ? 'radio-checked' : ''"-->
    <!--                                             color="#3E7662"-->
    <!--                                             label="รายงานเหตุการณ์การไม่พึ่งประสงค์จากยา (Adverse Drug Reaction Report)"-->
    <!--                                             value="8"-->
    <!--                                    />-->
    <!--                                </v-flex>-->
    <!--                            </v-layout>-->
    <!--                        </v-flex>-->
    <!--                    </v-layout>-->
    <!--                </v-radio-group>-->
    <!--            </v-flex>-->
    <!--        </v-layout>-->

    <v-layout>
      <v-flex style="color: #3E7662;">
        <v-radio-group hide-details v-model="filter">
          <v-layout class="my-1">
            <v-flex class="xs6 py-1">
              <v-layout>
                <v-flex class="xs1 align-center d-flex justify-end">
                  <v-icon v-if="countRF12 > 0" small color="#CC3D45">mdi-alert-circle</v-icon>
                  <span style="color: #CC3D45;font-weight: bold;font-size: 14px" v-if="countRF12 > 0">{{ countRF12
                    }}</span>
                </v-flex>
                <v-flex xs11>
                  <v-radio class="ml-3" @click.native="checkRadio('1')" :class="checkRadio1 ? 'radio-checked' : ''"
                    color="#3E7662" label="แบบรายงานการแก้ไขเพิ่มเติมโครงร่างการวิจัย (RF 12_2563)" value="1" />
                  <!--                             label="รายงานแก้ไขเพิ่มเติมโครงร่างการวิจัย (Amendment Protocol)"-->
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex class="xs6 py-1">
              <v-layout>
                <v-flex class="xs1 align-center d-flex justify-end">
                  <v-icon v-if="countRF03 > 0" small color="#CC3D45">mdi-alert-circle</v-icon>
                  <span style="color: #CC3D45;font-weight: bold;font-size: 14px" v-if="countRF03 > 0">{{ countRF03
                    }}</span>
                </v-flex>
                <v-flex xs11>
                  <v-radio class="ml-3" @click.native="checkRadio('4')" :class="checkRadio4 ? 'radio-checked' : ''"
                    color="#3E7662" label="แบบรายงานความก้าวหน้าของการวิจัย/ขอต่ออายุโครงการ (RF 03_2563)" value="4" />
                  <!--                             label="รายงานความก้าวหน้าและขอต่ออายุโครงการวิจัย (Progress Report)"-->
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout class="my-1">
            <v-flex class="xs6 py-1">
              <v-layout>
                <v-flex class="xs1 align-center d-flex justify-end">
                  <v-icon v-if="countRF04_2 > 0" small color="#CC3D45">mdi-alert-circle</v-icon>
                  <span style="color: #CC3D45;font-weight: bold;font-size: 14px" v-if="countRF04_2 > 0">{{ countRF04_2
                    }}</span>
                </v-flex>
                <v-flex xs11>
                  <v-radio class="ml-3" @click.native="checkRadio('8')" :class="checkRadio8 ? 'radio-checked' : ''"
                    color="#3E7662" label="แบบรายงานเหตุการณ์ไม่พึงประสงค์จากยา/เหตุการณ์ไม่คาดคิดจากยา (RF 04_1_2563)"
                    value="8" />
                  <!--                             label="รายงานเหตุการณ์การไม่พึ่งประสงค์จากยา (Adverse Drug Reaction Report)"-->
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex class="xs6 py-1">
              <v-layout>
                <v-flex class="xs1 align-center d-flex justify-end">
                  <v-icon v-if="countRF06 > 0" small color="#CC3D45">mdi-alert-circle</v-icon>
                  <span style="color: #CC3D45;font-weight: bold;" v-if="countRF06 > 0">{{ countRF06 }}</span>
                </v-flex>
                <v-flex xs11>
                  <v-radio class="ml-3" @click.native="checkRadio('5')" :class="checkRadio5 ? 'radio-checked' : ''"
                    color="#3E7662" label="แบบรายงานแจ้งปิด/สรุปผลการวิจัย (RF 06_2563)" value="5" />
                  <!--                             label="รายงานสรุปผลการวิจัย (Final Report)"-->
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout class="my-1">
            <v-flex class="xs6 py-1">
              <v-layout>
                <v-flex class="xs1 align-center d-flex justify-end">
                  <v-icon v-if="countRF04_1 > 0" small color="#CC3D45">mdi-alert-circle</v-icon>
                  <span style="color: #CC3D45;font-weight: bold;font-size: 14px" v-if="countRF04_1 > 0">{{ countRF04_1
                    }}</span>
                </v-flex>
                <v-flex xs11>
                  <v-radio class="ml-3" @click.native="checkRadio('2')" :class="checkRadio2 ? 'radio-checked' : ''"
                    color="#3E7662" label="แบบรายงานเหตุการณ์ไม่พึงประสงค์ (SAE) (RF 04_2_2563)" value="2" />
                  <!--                             label="รายงานเหตุการณ์การไม่พึ่งประสงค์ (SAE Report)"-->
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex class="xs6 py-1">
              <v-layout>
                <v-flex class="xs1 align-center d-flex justify-end">
                  <v-icon v-if="countRF07 > 0" small color="#CC3D45">mdi-alert-circle</v-icon>
                  <span style="color: #CC3D45;font-weight: bold;font-size: 14px" v-if="countRF07 > 0">{{ countRF07
                    }}</span>
                </v-flex>
                <v-flex xs11>
                  <v-radio class="ml-3" @click.native="checkRadio('7')" :class="checkRadio7 ? 'radio-checked' : ''"
                    color="#3E7662" label="แบบรายงานการยุติโครงการวิจัยก่อนกําหนด (RF 07_2563)" value="7" />
                  <!--                             label="แจ้งปิดโครงการวิจัยก่อนกำหนด (Terminate)"-->
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout class="my-1">
            <v-flex class="xs6 py-1">
              <v-layout>
                <v-flex class="xs1 align-center d-flex justify-end">
                  <v-icon v-if="countRF05 > 0" small color="#CC3D45">mdi-alert-circle</v-icon>
                  <span style="color: #CC3D45;font-weight: bold;font-size: 14px" v-if="countRF05 > 0">{{ countRF05
                    }}</span>
                </v-flex>
                <v-flex xs11>
                  <v-radio class="ml-3" @click.native="checkRadio('3')" :class="checkRadio3 ? 'radio-checked' : ''"
                    color="#3E7662" label="แบบรายงานการไม่ปฏิบัติตามข้อกำหนด (RF 05_2563)" value="3" />
                  <!--                             label="รายงานการเบี่ยงเบนโครงร่างวิจัย (Deviation Report)"-->
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex class="xs6 py-1">
              <v-layout>
                <v-flex class="xs1 align-center d-flex justify-end">
                  <v-icon v-if="countCorres > 0" small color="#CC3D45">mdi-alert-circle</v-icon>
                  <span style="color: #CC3D45;font-weight: bold;font-size: 14px" v-if="countCorres > 0">{{ countCorres
                    }}</span>
                </v-flex>
                <v-flex xs11>
                  <v-radio class="ml-3" @click.native="checkRadio('6')" :class="checkRadio6 ? 'radio-checked' : ''"
                    color="#3E7662" label="เอกสารและจดหมายแจ้งเกี่ยวกับงานวิจัย (Correspondence Report)" value="6" />
                  <!--                             label="แจ้งปิดโครงการวิจัยก่อนกำหนด (Terminate)"-->
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout class="my-1">
            <v-flex class="xs6 py-1"></v-flex>
            <v-flex class="xs6 py-1">
              <v-layout>
                <v-flex class="xs1 align-center d-flex justify-end">
                  <v-icon v-if="countSusar > 0" small color="#CC3D45">mdi-alert-circle</v-icon>
                  <span style="color: #CC3D45;font-weight: bold;font-size: 14px" v-if="countSusar > 0">{{ countSusar
                    }}</span>
                </v-flex>
                <v-flex xs11>
                  <v-radio class="ml-3" @click.native="checkRadio('9')" :class="checkRadio9 ? 'radio-checked' : ''"
                    color="#3E7662" label="แบบรายงานเหตุการณ์ไม่พึ่งประสงค์นอกสถาบัน SUSAR / DMC / DSMB" value="9" />
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-radio-group>
      </v-flex>
    </v-layout>

    <v-layout my-6>
      <v-flex xs3>
        <v-text-field placeholder="รหัสโครงการวิจัย" color="#3e7662" dense outlined v-model="searchData.researchCode"
          hide-details />
      </v-flex>
      <v-flex xs3 mx-6>
        <v-text-field placeholder="ชื่อ นามสกุล ผู้วิจัย" color="#3e7662" dense outlined
          v-model="searchData.researcherName" hide-details />
      </v-flex>
      <v-flex shrink>
        <v-btn color="#3e7662" dark @click="getRF(1)">
          <span class="font-weight-bold">ค้นหา</span>
        </v-btn>
      </v-flex>
    </v-layout>

    <!-- Table -->
    <v-layout mt-4>
      <v-flex>
        <form-table :headers="headers" :items="dataPostApproveList" onViewData :on-approve-r-f="onApproveRF"
          :onMailSend="onMailSend" :viewCorresFile="viewCorresFile" :onMailResend="onMailResend"
          :on-approve-regen="onApproveRegen"></form-table>
      </v-flex>
    </v-layout>

    <!-- Pagination -->
    <v-layout mt-12>
      <v-flex>
        <v-pagination color="#3E7662" :length="paginate.last_page" :total-visible="9" @input="getRF"
          v-model="paginate.current_page"></v-pagination>
      </v-flex>
    </v-layout>

    <!-- MODAL -->
    <template>
      <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="900px">
          <v-layout class="py-2 font-weight-bold" style="background-color: #3e7662;color: white;font-size: 18px;">
            <v-flex>
              <span>อนุมัติเอกสาร RF</span>
            </v-flex>
          </v-layout>
          <v-card class="px-6 py-6">
            <!-- CHECK FORM  -->

            <!-- ยืนยันตัวตน -->
            <v-layout v-if="filter !== '1'" class="py-2 font-weight-bold"
              style="background-color: #3e7662;color: white;font-size: 18px;">
              <v-flex>
                <span>ยืนยันตัวตน</span>
              </v-flex>
            </v-layout>

            <v-layout v-if="filter === '1'" class="py-2 font-weight-bold" style="font-size: 18px;">
              <v-flex>
                <span>ยืนยันตัวตน</span>
              </v-flex>
            </v-layout>

            <v-layout class="py-4">
              <v-flex>
                <span style="font-weight: bold;color: #CC3D45;">
                  *การยืนยันตัวตนนี้ เพื่อเป็นการ "ลงนามอนุมัติ"
                  งานวิจัยสำหรับผู้มีสิทธิ์ในการอนุมัติเท่านั้น
                </span>
              </v-flex>
            </v-layout>

            <v-layout class="pt-4">
              <v-flex xs3 mr-3 justify-end align-center d-flex>
                <span style="font-weight: bold;">Email: </span>
              </v-flex>
              <v-flex xs6 justify-start align-center d-flex>
                <v-text-field color="#3e7662" v-model="form.email" dense outlined hide-details />
              </v-flex>
            </v-layout>
            <v-layout mt-6>
              <v-flex xs3 mr-3 justify-end align-center d-flex>
                <span style="font-weight: bold;">Password: </span>
              </v-flex>
              <v-flex xs6 justify-start align-center d-flex>
                <v-text-field type="password" color="#3e7662" v-model="form.password" outlined dense hide-details
                  @keyup.enter="approveRF" />
              </v-flex>
            </v-layout>

            <v-card-actions class="mt-6">
              <v-layout class="justify-center">
                <v-flex shrink mr-6 justify-end>
                  <v-btn depressed style="font-weight: bold" @click="dialog = false"><span
                      style="color: #3e7662">ยกเลิก</span></v-btn>
                </v-flex>
                <v-flex shrink justify-end>
                  <v-btn depressed dark color="#3E7662" style="font-weight: bold" @click="approveRF">ยืนยัน</v-btn>
                </v-flex>
              </v-layout>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <!--EMAIL SEND MODAL-->
    <template>
      <v-row justify="center">
        <v-dialog v-model="emailDialog" persistent max-width="800px">
          <v-card>
            <!-- Header 1 -->
            <v-card-title class="justify-center font-weight-bold"
              style="background-color: #3e7662;color: #fff;font-size: 26px">
              <span>ส่ง Email</span>
            </v-card-title>
            <!-- Card text 1 -->

            <!-- Card แนบเอกสาร (มีตราประทับ) -->
            <v-card-text class="pa-12">
              <v-layout class="py-2 font-weight-bold" style="background-color: #3e7662;color: white;font-size: 18px;">
                <v-flex>
                  <span>แนบเอกสาร (มีตราประทับ)</span>
                </v-flex>
              </v-layout>
              <v-card class="px-6 pb-6">
                <v-layout>
                  <v-flex mt-2 xs5>
                    <p style="color: red;text-align: left;font-weight: bold">
                      *PDF Version 1.4 เท่านั้น!
                    </p>
                  </v-flex>
                  <v-flex xs6 mt-6 style="text-align: right;">
                    <v-btn min-width="5px" small dark style="background-color: #3E7662;padding: 5px"
                      @click="add('attachFiles')">
                      <v-icon small>add</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex xs1 ml-2></v-flex>
                </v-layout>

                <v-layout v-for="(item, i) in emailForm.attachStampFiles" :key="i" mb-6 mt-6 class="justify-center">
                  <v-flex xs5>
                    <v-layout>
                      <v-flex shrink mr-3 class="pt-2">
                        <span class="font-weight-bold">ชื่อเอกสาร</span>
                      </v-flex>
                      <v-flex>
                        <v-text-field prepend-icon="" v-model="item.name" outlined dense background-color="#FBF6F3"
                          color="#3E7662" item-color="#3E7662"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs6 pl-4>
                    <v-layout class="justify-center">
                      <v-flex shrink class="pt-3 font-weight-bold mr-3">ไฟล์</v-flex>
                      <v-flex>
                        <v-layout class="mb-2">
                          <v-flex xs10 class="text-start">
                            <v-file-input accept=".pdf" prepend-icon="" :id="'stampFile' + i" :model="item.file"
                              outlined dense background-color="#FBF6F3" color="#3E7662" item-color="#3E7662"
                              @change="setDataUploadDynamicStampFile($event, i)" hide-details></v-file-input>
                          </v-flex>
                          <v-flex shrink pl-4 style="text-align: left" class="d-flex align-center">
                            <v-btn color="#3E7662" dark @click="uploadDynamicStampFile('stampFile' + i)">
                              <v-icon class="pr-3">cloud_download</v-icon>
                              <span>Upload</span>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs1 pt-2 ml-2>
                    <v-btn v-if="emailForm.attachStampFiles.length > 1" min-width="5px" small dark
                      style="background-color: #CC3D45;padding: 5px" @click="remove(i)">
                      <v-icon small>remove</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-card>

              <v-layout class="py-2 font-weight-bold" style="background-color: #3e7662;color: white;font-size: 18px;">
                <v-flex>
                  <span>แนบเอกสาร (ไม่มีตราประทับ)</span>
                </v-flex>
              </v-layout>
              <v-card class="px-6 pb-6">
                <v-layout>
                  <v-flex mt-2 xs5>
                    <p style="color: red;text-align: left;font-weight: bold">
                      *PDF เท่านั้น!
                    </p>
                  </v-flex>
                  <v-flex xs6 mt-6 style="text-align: right;">
                    <v-btn min-width="5px" small dark style="background-color: #3E7662;padding: 5px" @click="add2">
                      <v-icon small>add</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex xs1 ml-2></v-flex>
                </v-layout>

                <v-layout v-for="(item, i) in emailForm.attachFiles" :key="i" mb-6 mt-6 class="justify-center">
                  <v-flex xs5>
                    <v-layout>
                      <v-flex shrink mr-3 class="pt-2">
                        <span class="font-weight-bold">ชื่อเอกสาร</span>
                      </v-flex>
                      <v-flex>
                        <v-text-field prepend-icon="" v-model="item.name" outlined dense background-color="#FBF6F3"
                          color="#3E7662" item-color="#3E7662"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs6 pl-4>
                    <v-layout class="justify-center">
                      <v-flex shrink class="pt-3 font-weight-bold mr-3">ไฟล์</v-flex>
                      <v-flex>
                        <v-layout class="mb-2">
                          <v-flex xs10 class="text-start">
                            <v-file-input accept=".pdf" prepend-icon="" :id="'file' + i" :model="item.file" outlined
                              dense background-color="#FBF6F3" color="#3E7662" item-color="#3E7662" @change="
                                setDataUploadDynamicFile(
                                  'attachFiles',
                                  $event,
                                  i
                                )
                                " hide-details></v-file-input>
                          </v-flex>
                          <v-flex shrink pl-4 style="text-align: left" class="d-flex align-center">
                            <v-btn color="#3E7662" dark @click="uploadDynamicFile('file' + i)">
                              <v-icon class="pr-3">cloud_download</v-icon>
                              <span>Upload</span>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs1 pt-2 ml-2>
                    <v-btn v-if="emailForm.attachFiles.length > 1" min-width="5px" small dark
                      style="background-color: #CC3D45;padding: 5px" @click="remove2(i)">
                      <v-icon small>remove</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-card-text>


            <v-card-actions class="pb-12 pr-12">
              <v-layout>
                <v-spacer></v-spacer>
                <v-flex shrink mr-3 justify-end>
                  <v-btn depressed style="font-weight: bold" @click="previewMail"><span
                      style="color: #3e7662">ดูตัวอย่างอีเมล</span></v-btn>
                </v-flex>
                <v-flex shrink mr-3 justify-end>
                  <v-btn depressed style="font-weight: bold" @click="emailDialog = false"><span
                      style="color: #3e7662">ยกเลิก</span></v-btn>
                </v-flex>
                <v-flex shrink justify-end>
                  <v-btn depressed dark color="#3E7662" style="font-weight: bold"
                    @click="sendApproveMail">ยืนยัน</v-btn>
                </v-flex>
              </v-layout>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <!-- Modal View To Reviewer Files -->
    <template>
      <v-row justify="center">
        <v-dialog v-model="viewFileDialog" persistent width="800px" max-width="80%">
          <v-card>
            <!-- Header -->
            <v-card-title class="mb-4 justify-center" style="background-color: #3e7662;color: white;">
              <span class="font-weight-medium font-weight-bold">ดูเอกสารแนบ</span>
            </v-card-title>
            <v-card-text class="justify-center" v-if="corresFile">
              <v-layout>
                <h2 style="margin: auto">
                  เอกสาร Correspondence
                </h2>
              </v-layout>
              <v-layout my-6>
                <v-flex>
                  <a :href="corresFile.file" style="color: #3e7662;" target="_blank">
                    <p style="font-size: 16px;text-align: center" class="my-2">
                      {{ corresFile.title ? corresFile.title : "ไม่มีชื่อ" }}
                    </p>
                  </a>
                </v-flex>
              </v-layout>
              <div v-if="corresOtherFile.length > 1" class="my-6">
                <v-layout>
                  <h2 style="margin: auto" class="mb-6">
                    เอกสาร อื่นๆ
                  </h2>
                </v-layout>
                <v-layout v-for="(file, k) in corresOtherFile" :key="k">
                  <v-flex ml-2 justify-center>
                    <a :href="file.filePath" style="color: #3e7662;" target="_blank">
                      <p style="font-size: 16px;text-align: center" class="my-2">
                        {{ file.title ? file.title : "ไม่มีชื่อ" }}
                      </p>
                    </a>
                  </v-flex>
                </v-layout>
              </div>
              <div v-else>
                <v-layout>
                  <v-flex my-12>
                    <p style="font-size: 18px;font-weight: bold; color: #3e7662;text-align: center">
                      ไม่พบเอกสารแนบ
                    </p>
                  </v-flex>
                </v-layout>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn style="font-weight: bold" color="#3E7662" text @click="viewFileDialog = false">
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <loading color="#527281" :active.sync="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>
  </v-content>
</template>

<script>
import FormTable from "../../components/table/FormTable";
import vSelect from "vue-select";
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-select/dist/vue-select.css";
import { mapState } from "vuex";
import axios from "axios";
import { domain } from "../../services/Constants";

export default {
  name: "Meeting",
  components: {
    FormTable,
    vSelect,
    Loading,
  },
  computed: {
    ...mapState({
      user: (state) => state.Auth.user,
    }),
  },
  data: () => ({
    isRegen: false,
    dialog: false,
    form: {
      email: "",
      password: "",
      id: "",
      filter: "",
      researchID: "",
    },
    filter: "1",
    emailType: "",
    checkRadio1: true,
    checkRadio2: false,
    checkRadio3: false,
    checkRadio4: false,
    checkRadio5: false,
    checkRadio6: false,
    checkRadio7: false,
    checkRadio8: false,
    checkRadio9: false,
    meetingDialog: false,
    isLoading: false,
    fullPage: true,
    paginate: {
      current_page: 1,
      from: 1,
      last_page: 1,
      per_page: 1,
      total: 1,
      to: 1,
    },
    headers: [
      {
        text: "ลำดับ",
        value: "number",
        align: "center",
        sortable: false,
        width: "5%",
      },
      {
        text: "ชื่องานวิจัย",
        value: "nameResearch",
        align: "center",
        sortable: false,
      },
      {
        text: "รหัสโครงร่าง การวิจัย",
        value: "researchCode",
        align: "center",
        sortable: false,
      },
      {
        text: "เรื่องที่",
        value: "groupID",
        align: "center",
        sortable: false,
        width: "10%",
      },
      {
        text: "สถานะ",
        value: "status",
        align: "center",
        sortable: false,
        width: "10%",
      },

      {
        text: "ดูแบบฟอร์ม",
        value: "viewOutline",
        align: "center",
        sortable: false,
        width: "10%",
      },
      {
        text: "อนุมัติ",
        value: "verify",
        align: "center",
        sortable: false,
        width: "10%",
      },
      {
        text: "ส่ง email",
        value: "emailSend",
        align: "center",
        sortable: false,
      },
      {
        text: "Download หนังสือตอบรับ",
        value: "viewPDF",
        align: "center",
        sortable: false,
        width: "10%",
      },
      {
        text: "สร้างเอกสารอีกครั้ง",
        value: "regenPDF",
        align: "center",
        sortable: false,
        width: "10%",
      },
    ],
    dataPostApproveList: [],
    countRF12: 0,
    countRF05: 0,
    countCorres: 0,
    countSusar: 0,
    countRF03: 0,
    countRF04_1: 0,
    countRF04_2: 0,
    countRF06: 0,
    countRF07: 0,
    emailDialog: false,
    corresOtherFile: [],
    corresFile: { file: '', title: '' },
    viewFileDialog: false,
    emailForm: {
      attachFiles: [
        {
          file: "",
          name: "",
        },
      ],
      attachStampFiles: [
        {
          file: "",
          name: "",
        },
      ],
      filter: 0,
      id: 0
    },
    searchData: {
      researchCode: "",
      researcherName: "",
      filterType: 0,
    },
  }),
  created() {
    // Check Permission Access
    //  if (this.user.currentRole !== 4) {
    //      this.$router.go(-1);
    //  }
    this.getRF(1);
  },
  methods: {
    onApproveRegen(val) {
      this.form.researchID = val.researchID;
      this.form.id = val.id;
      this.form.filter = this.filter;
      this.form.email = this.user.email;
      Swal.fire({
        title: 'คุณต้องการสร้างเอกสารอีกครั้งหรือไม่?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3E7662',
        cancelButtonColor: 'rgb(189, 189, 189)',
        confirmButtonText: 'ใช่ บันทึก',
      }).then((result) => {
        if (result.value) {
          this.approveResearch();
        }
      })
    },
    approveResearch() {
      this.isLoading = true;
      let api = 'Auth/approveRegenPost'
      let title = 'อนุมัติงานวิจัยเรียบร้อยแล้ว'
      this.$store
        .dispatch(api, this.form)
        .then((res) => {
          this.isLoading = false;
          Swal.fire({
            position: "center",
            icon: "success",
            title: title,
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {
            location.reload();
            this.form.email = "";
            this.form.password = "";
            this.form.month = "";
            this.form.ortherMonth = "";
            this.dialog = false;
            this.getPaginateResearchFilter(1);
          });
        })
        .catch((e) => {
          if (e.response && e.response.message) {
            Swal.fire({
              icon: "error",
              title: e.response.message,
              text: e.response.data.message,
              confirmButtonColor: "#3E7662",
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "เกิดข้อผิดพลาด",
              text: e.response.data.message,
              confirmButtonColor: "#3E7662",
            });
          }
          this.form.email = "";
          this.form.password = "";
          this.form.month = "";
          this.form.ortherMonth = "";
          this.isLoading = false;
          this.dialog = false;
        });
    },
    onMailSend(val) {
      this.emailForm.id = val.id;
      this.emailForm.researchID = val.researchID;
      this.emailDialog = true;
    },
    add() {
      this.emailForm.attachStampFiles.push({ name: "", file: "" });
    },
    remove(index) {
      this.emailForm.attachStampFiles.splice(index, 1);
    },
    add2() {
      this.emailForm.attachFiles.push({ name: "", file: "" });
    },
    remove2(index) {
      this.emailForm.attachFiles.splice(index, 1);
    },
    uploadDynamicFile(val) {
      document.getElementById(val).click();
    },
    setDataUploadDynamicFile(name, val, index) {
      this.isLoading = true
      var formData = new FormData();
      formData.append("approveMailAttachFile", val);
      axios
        .post(domain + "/api/upload-file-pre", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.emailForm[name][index].file = response.data.fileName;
          this.isLoading = false
        })
        .catch(function (error) {
          this.isLoading = false;
          console.log(error);
        });
    },
    uploadDynamicStampFile(val) {
      document.getElementById(val).click();
    },
    setDataUploadDynamicStampFile(val, index) {
      this.isLoading = true;
      var formData = new FormData();
      formData.append("approveMailAttachFile", val);
      axios
        .post(domain + "/api/upload-file-pre", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.emailForm.attachStampFiles[index].file = response.data.fileName;
          this.isLoading = false;
        })
        .catch(function (error) {
          this.isLoading = false;
        });
    },
    viewCorresFile(item) {
      this.viewFileDialog = true;
      this.corresOtherFile = item.otherFile;
      this.corresFile.file = item.corresFile;
      this.corresFile.title = item.corresName;
    },
    getRF(page) {
      this.dataPostApproveList = [];
      switch (this.filter) {
        case '1':
          this.emailType = 'approve_rf12';
          break;
        case '2':
          this.emailType = 'approve_rf04_2';
          break;
        case '3':
          this.emailType = 'approve_rf05';
          break;
        case '4':
          this.emailType = 'approve_rf03';
          break;
        case '5':
          this.emailType = 'approve_rf06';
          break;
        case '6':
          this.emailType = 'approve_report';
          break;
        case '7':
          this.emailType = 'approve_rf07';
          break;
        case '8':
          this.emailType = 'approve_rf04_1';
          break;
        case '9':
          this.emailType = 'approve_susar';
          break;
      }
      let data = {
        page: page,
        filter: this.filter,
        researchCode: this.searchData.researchCode,
        researcherName: this.searchData.researcherName,
      };
      this.isLoading = true;
      this.$store
        .dispatch("Research/getRFApprove", data)
        .then((res) => {
          this.countRF12 = res.ResearchAmendmentCount;
          this.countRF04_1 = res.AdverseEventCount;
          this.countRF05 = res.DeviationReportCount;
          this.countRF03 = res.ProgressReportCount;
          this.countRF06 = res.ResearchSummarizeCount;
          this.countRF07 = res.ResearchTerminationCount;
          this.countRF04_2 = res.AdverseDrugEventCount;
          this.countCorres = res.CorrespondenceCount;
          this.countSusar = res.FormSusarCount;
          let i = 1;
          res.data.data.forEach((data) => {
            this.dataPostApproveList.push({
              number: i,
              id: data.id,
              researchID: data.researchID,
              nameResearch: data.researchName,
              researchCode: data.researchCode,
              groupID: data.group_id + 1,
              // status: data.status,
              linkEdit: this.checkLink(),
              otherFile: data.otherFile,
              corresFile: data.file,
              corresName: data.name,
              filterType: this.filter,
              researchCode: data.researchCode,
              onView: 8,
              item: data,
              status: data.status,
              isSendApproveMail: data.isSendApproveMail == 1,
              mailLink: domain + 'research-email/' + data.researchID + '?email_type=' + this.emailType,
            });
            i++;
          });

          this.paginate.current_page = res.data.current_page;
          this.paginate.from = res.data.from;
          this.paginate.last_page = res.data.last_page;
          this.paginate.per_page = res.data.per_page;
          this.paginate.total = res.data.total;
          this.paginate.to = res.data.to;
          this.isLoading = false;
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    checkLink() {
      if (this.filter === "1") {
        return "ViewFormRF12";
      }
      if (this.filter === "2") {
        return "ViewFormRF04_2";
      }
      if (this.filter === "3") {
        return "ViewFormRF05";
      }
      if (this.filter === "4") {
        return "ViewFormRF03";
      }
      if (this.filter === "5") {
        return "ViewFormRF06";
      }
      if (this.filter === "7") {
        return "ViewFormRF07";
      }
      if (this.filter === "8") {
        return "ViewFormRF04_1";
      }
      if (this.filter === "9") {
        return "ViewFormRFSusar";
      }
    },
    checkRadio(name) {
      if (name === "1") {
        this.checkRadio1 = true;
        this.checkRadio2 = false;
        this.checkRadio3 = false;
        this.checkRadio4 = false;
        this.checkRadio5 = false;
        this.checkRadio6 = false;
        this.checkRadio7 = false;
        this.checkRadio8 = false;
        this.checkRadio9 = false;
      }
      if (name === "2") {
        this.checkRadio1 = false;
        this.checkRadio2 = true;
        this.checkRadio3 = false;
        this.checkRadio4 = false;
        this.checkRadio5 = false;
        this.checkRadio6 = false;
        this.checkRadio7 = false;
        this.checkRadio8 = false;
        this.checkRadio9 = false;
      }
      if (name === "3") {
        this.checkRadio1 = false;
        this.checkRadio2 = false;
        this.checkRadio3 = true;
        this.checkRadio4 = false;
        this.checkRadio5 = false;
        this.checkRadio6 = false;
        this.checkRadio7 = false;
        this.checkRadio8 = false;
        this.checkRadio9 = false;
      }
      if (name === "4") {
        this.checkRadio1 = false;
        this.checkRadio2 = false;
        this.checkRadio3 = false;
        this.checkRadio4 = true;
        this.checkRadio5 = false;
        this.checkRadio6 = false;
        this.checkRadio7 = false;
        this.checkRadio8 = false;
        this.checkRadio9 = false;
      }
      if (name === "5") {
        this.checkRadio1 = false;
        this.checkRadio2 = false;
        this.checkRadio3 = false;
        this.checkRadio4 = false;
        this.checkRadio5 = true;
        this.checkRadio6 = false;
        this.checkRadio7 = false;
        this.checkRadio8 = false;
        this.checkRadio9 = false;
      }
      if (name === "6") {
        this.checkRadio1 = false;
        this.checkRadio2 = false;
        this.checkRadio3 = false;
        this.checkRadio4 = false;
        this.checkRadio5 = false;
        this.checkRadio6 = true;
        this.checkRadio7 = false;
        this.checkRadio8 = false;
        this.checkRadio9 = false;
      }
      if (name === "7") {
        this.checkRadio1 = false;
        this.checkRadio2 = false;
        this.checkRadio3 = false;
        this.checkRadio4 = false;
        this.checkRadio5 = false;
        this.checkRadio6 = false;
        this.checkRadio7 = true;
        this.checkRadio8 = false;
        this.checkRadio9 = false;
      }
      if (name === "8") {
        this.checkRadio1 = false;
        this.checkRadio2 = false;
        this.checkRadio3 = false;
        this.checkRadio4 = false;
        this.checkRadio5 = false;
        this.checkRadio6 = false;
        this.checkRadio7 = false;
        this.checkRadio8 = true;
        this.checkRadio9 = false;
      }
      if (name === "9") {
        this.checkRadio1 = false;
        this.checkRadio2 = false;
        this.checkRadio3 = false;
        this.checkRadio4 = false;
        this.checkRadio5 = false;
        this.checkRadio6 = false;
        this.checkRadio7 = false;
        this.checkRadio8 = false;
        this.checkRadio9 = true;
      }
      this.getRF(1);
    },
    onApproveRF(val) {
      this.form.id = val.id;
      this.form.filter = this.filter;
      this.form.researchID = val.researchID;
      this.dialog = true;
    },
    onMailResend(id) {
      Swal.fire({
        title: "ท่านต้องการส่งอีเมลอีกครั้งหรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        confirmButtonText: "ต้องการ",
        cancelButtonText: "ยกเลิก",
      }).then((res) => {
        if (res.value) {
          this.isLoading = true;
          let payload = { 'id': id, 'email_type': 'approve' }
          this.$store.dispatch("Research/researchEmailResend", payload)
            .then((res) => {
              this.isLoading = false;
              Swal.fire({
                position: "center",
                icon: "success",
                title: "ส่งอีเมลซ้ำเรียบร้อยแล้ว",
                showConfirmButton: false,
                timer: 1500,
              })
            }).catch((e) => {
              Swal.fire({
                icon: "error",
                title: "เกิดข้อผิดพลาด",
                text: e.response.data.message,
                confirmButtonColor: "#3E7662",
              });
              this.isLoading = false;
            });
        }
      })
    },
    approveRF() {
      this.isLoading = true;
      this.$store
        .dispatch("FormRF/ApproveRF", this.form)
        .then((res) => {
          this.isLoading = false;
          Swal.fire({
            position: "center",
            icon: "success",
            title: "อนุมัติเอกสาร RF เรียบร้อยแล้ว",
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {
            this.dialog = false;
            this.getRF(1);
          });
        })
        .catch((e) => {
          this.isLoading = false;
          Swal.fire({
            icon: "error",
            title: "เกิดข้อผิดพลาด",
            text: e.response.data.message,
            confirmButtonColor: "#3E7662",
          });
          this.dialog = false;
        });
    },
    clear(val) {
      if (val === "1") {
        this.form.progressReport.afterEdit = "";
        this.form.progressReport.suspension = "";
        this.form.progressReport.termination = "";
      }
      if (val === "2") {
        this.form.progressReport.frequency = "";
        this.form.progressReport.suspension = "";
        this.form.progressReport.termination = "";
      }
      if (val === "3") {
        this.form.progressReport.frequency = "";
        this.form.progressReport.afterEdit = "";
        this.form.progressReport.termination = "";
      }
      if (val === "4") {
        this.form.progressReport.frequency = "";
        this.form.progressReport.suspension = "";
        this.form.progressReport.afterEdit = "";
      }
    },
    clearSAE(val) {
      if (val === "1") {
        this.form.saeReport.gotItHaveChange = "";
        this.form.saeReport.siteVisit = "";
        this.form.saeReport.suspension = "";
      }
      if (val === "2") {
        this.form.saeReport.gotItHaveChange = "";
        this.form.saeReport.siteVisit = "";
        this.form.saeReport.suspension = "";
      }
      if (val === "3") {
        this.form.saeReport.siteVisit = "";
        this.form.saeReport.suspension = "";
      }
      if (val === "4") {
        this.form.saeReport.gotItHaveChange = "";
        this.form.saeReport.suspension = "";
      }
      if (val === "5") {
        this.form.saeReport.gotItHaveChange = "";
        this.form.saeReport.siteVisit = "";
      }
    },
    clearAdverseDrug(val) {
      if (val === "1") {
        this.form.adverseDrug.gotItHaveChange = "";
        this.form.adverseDrug.siteVisit = "";
        this.form.adverseDrug.suspension = "";
      }
      if (val === "2") {
        this.form.adverseDrug.gotItHaveChange = "";
        this.form.adverseDrug.siteVisit = "";
        this.form.adverseDrug.suspension = "";
      }
      if (val === "3") {
        this.form.adverseDrug.siteVisit = "";
        this.form.adverseDrug.suspension = "";
      }
      if (val === "4") {
        this.form.adverseDrug.gotItHaveChange = "";
        this.form.adverseDrug.suspension = "";
      }
      if (val === "5") {
        this.form.adverseDrug.gotItHaveChange = "";
        this.form.adverseDrug.siteVisit = "";
      }
    },
    clearDeviation(val) {
      if (val === "1") {
        this.form.deviationReport.recommend = "";
      }
      if (val === "2") {
        this.form.deviationReport.demand = "";
      }
    },
    clearTermination(val) {
      if (val === "1") {
        this.form.terminationReport.recommend = "";
      }
      if (val === "2") {
        this.form.terminationReport.demand = "";
      }
    },
    previewMail() {
      this.isLoading = true;
      this.emailForm.filter = this.filter;
      this.$store.dispatch("Research/previewApproveMail", this.emailForm)
        .then((res) => {
          var pageLink = "about:blank";
          var pwa = window.open(pageLink, "_new");
          pwa.document.open();
          pwa.document.write(res);
          pwa.document.close();
          this.isLoading = false;
        })
        .catch((e) => {
          Swal.fire({
            icon: "error",
            title: "เกิดข้อผิดพลาด",
            text: e.response.data.message,
            confirmButtonColor: "#3E7662",
          });
          this.isLoading = false;
        });
    },
    sendApproveMail() {
      this.isLoading = true;
      this.emailForm.filter = this.filter;
      this.email.userID =
        this.$store
          .dispatch("Research/sendPostApproveMail", this.emailForm)
          .then((res) => {
            this.isLoading = false;
            Swal.fire({
              position: "center",
              icon: "success",
              title: "อนุมัติงานวิจัยเรียบร้อยแล้ว",
              showConfirmButton: false,
              timer: 1500,
            }).then(() => {
              this.emailForm = {
                attachFiles: [
                  {
                    file: "",
                    name: "",
                  },
                ],
                attachStampFiles: [
                  {
                    file: "",
                    name: "",
                  },
                ],
              };
              this.emailForm.researchID = "";
              this.emailDialog = false;
              // this.getRF(1);
              // this.getResearchApprove(1);
              location.reload();
            });
          })
          .catch((e) => {
            Swal.fire({
              icon: "error",
              title: "เกิดข้อผิดพลาด",
              text: e.response.data.message,
              confirmButtonColor: "#3E7662",
            });
            this.isLoading = false;
            this.dialog = false;
          });
    },
  },
};
</script>

<style lang="scss">
// V-select
.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__selected

/*.style-chooser .vs__dropdown-menu:hover*/
  {
  background: #3e7662;
  border: solid 2px #3e7662;
  color: #fff;
  /*text-transform: lowercase;*/
  /*font-variant: small-caps;*/
}

.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
  fill: #fff;
}
</style>
